declare var window: any;

export function setTexts(locale, texts) {
    const source = window.MessageSource || {};
    source.locale = locale;
    source.texts = Object.assign(source.texts || {}, texts);
    window.MessageSource = source
}
